import gql from 'graphql-tag'

export const repliesTranslations = gql`
query repliesTranslations($lang: String, $repliesIds: [Int]!) {
  repliesTranslations(lang: $lang, repliesIds: $repliesIds) {
    replyId
    text
  }
}
`